var _style, _polygon, _polygon2, _polygon3, _rect, _rect2, _polygon4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg42(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 81.5",
    style: {
      enableBackground: "new 0 0 300 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "125.7,36 138.9,16.1 149.8,16.1 133.7,40.4 150.6,64.7 139.3,64.7 125.7,44.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "221.2,16.1 230.6,16.1 230.6,55.9 253.6,55.9 253.6,64.7 221.2,64.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "267.3,16.1 267.3,64.7 300,64.7 300,55.9 276.7,55.9 276.7,24.8 300,24.8 300,16.1 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 16.1,
    className: "st0",
    width: 9.4,
    height: 48.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 281.5,
    y: 36,
    className: "st0",
    width: 9,
    height: 8.7
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,-0.4 0,81.2 73.6,81.2 73.6,72.5 9.8,72.5 9.8,8.3 73.6,8.3 73.6,-0.4 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,51.3h-17.2l-3.8,13.3h-9.8l15.4-48.6h13.8l15.5,48.6h-10.1L191.7,51.3z M177,42.7h12l-5-18.3h-1.8 L177,42.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73,65.6c14.4,0,19.6-8.2,19.6-15.3c0-7.8-4.4-12.6-13.2-14.2l-9.1-1.7C67.3,34,64,32.9,64,29.3 c0-4.2,4.2-5.7,8.2-5.7c5.2,0,8.1,1.8,9,5.6H91c-1.2-8.7-8-14-18.7-14C59.7,15.1,54,22.4,54,29.7s4.3,11.8,12.4,13.2l9.3,1.6 c3.3,0.6,6.8,1.8,6.8,6.3c0,3.9-3.5,6.3-9.1,6.3c-6.4,0-10.2-2.4-11-7.1h-9.8C53.8,59.8,61.1,65.6,73,65.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg42);
export default __webpack_public_path__ + "static/media/42.84429ec49b31966f0172ead4898f8add.svg";
export { ForwardRef as ReactComponent };